export const adminState = {
  microsoftLogin: false,
  googleLogin: false,
  feideLoginStatus: false,
  educatoremail: '',
  logintype: '',
  serversysinfo: {},
  serverUrl: '',
  registryUrl: '',
  accessToken: '',
  serverAccessToken: '',
  idtoken: {},
  accessTokenExpires: '',
  displayName: '',
  userid: '',
  eduParams: {},
  affiliation: '',
  groups: {},
  loggedin: false,
  bgroups: {},
  ugroups: {},
  orggroups: {},
  feideorganisations: {},
  privateKey: ' ',
  publicKey: '',
  appsecret: '',
  sid: '',
  picture: '',
  learnerinfo: {},
  educatorinfo: {},
  orginfo: {},
  grepKompetanseMaal: {},
  learnerkmsdata: {},
  showIntro: true,
  learnerhomeworktime: {},
  learnerreadingtime: {},
  learnerschoolgroupassessment: {},
  learnersubjectschoolclass: {},
  learnersubjectassessment: {},
  setlearnersdoughnutkms: {},
  setsubjectwordcloud: {},
  searchdate: {},
  groupSubject: {},
  setlearnersgroupinformation: {},
  learnerssubjectinformationcontribution: {},
  unreadnoteslearner: new Map(),
  unreadnotessubject: new Map(),
  numberofunreadnotes: 0,
  educatorcurriculum: new Map(),
  proudof: {},
  environment: 'prod',
  learningenvironment: [],
  schoolclasses: {},
  socialcommongroup: {},
  socialquestions: {},
  schoolinfo: {},
  learnersocialmap: {},
  educatoruid: '',
  lang: 'nob',
  license: false,
  loginprocess: false,
  // Login flow after the Feide callback: '' | 'running' | 'error' - kept in the store, because the login view
  // can be remounted while the flow runs (App.vue swaps its <router-view>)
  loginFlow: '',
  loginErrorMsg: '',
  ssoprocess: false,
  callback: '',
  callbackstate: '',
  toFromDate: {
    fromDate: '2020-01-01T00:00:00',
    toDate: '2049-12-31T23:59:59'
  },
  activesubject: {},
  assignmentTemplate: {},
  /* ************************************** */
  /*        NEW DESIGN FROM NICHLAS         */
  /* ************************************** */
  theme: 'light',
  activeNav: -1,
  setmenutop: false,
  isloggingin: false,
  hasgrepdata: true,
  smallscreen: true,
  /* V4L */
  writtenassignmenttobeassessed: {},
  assignmentcomments: [],
  grammarfeedback: [],
  notassessed: {},
  learnerassess: [],
  onlyV4L: true,
  plagiarismscanid: '',
  plagiarismdata: {},
  openguidancepanel: -1,
  addone: 0,
  learnerwrittenassignment: '',
  aflassignmentsmap: new Map(),
  experimental: false, // false,
  offDisabled: false,
  assignmentlanguage: 'nb',
  competencygoals: {},
  /* *************************** */
  /*  Google and Microsoft login */
  /* *************************** */
  domain: '',
  dbConnectionGettingEducator: false,
  geteu: false
}
